import React from "react";
import _ from "lodash";

import classNames from "classnames";
import classes from "./GenericCheckBoxView.scss";

const GenericCheckBoxView = ({ item, textboxValue }) => {
  const { label, subText } = item;

  const labelClassName = classNames(classes.label, {
    "text-body": _.isEmpty(subText),
    "text-label": !_.isEmpty(subText),
  });

  return (
    <div className={classes.container}>
      <span className={classNames(classes.dot, "text-label")}>•</span>

      <div className={classes.contentContainer}>
        <span className={labelClassName}>{label}</span>
        {textboxValue && (
          <span className={classNames("text-body", classes.label)}>
            {textboxValue}
          </span>
        )}
      </div>
    </div>
  );
};

export default GenericCheckBoxView;
